const PitcairnIslandsSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112161)">
      <path
        d="M40 20C40 31.0456 31.0456 40 20 40C8.95437 40 0 31.0456 0 20C0 20.0048 20 0.0021875 20 0C31.0456 0 40 8.95437 40 20Z"
        fill="#0052B4"
      />
      <path
        d="M19.9468 19.9998H20.0003C20.0003 19.9818 20.0003 19.9643 20.0003 19.9463C19.9825 19.9642 19.9647 19.982 19.9468 19.9998Z"
        fill="#F0F0F0"
      />
      <path
        d="M20 10.4348C20 6.91563 20 4.60977 20 0H19.9966C8.95242 0.001875 0 8.95539 0 20H10.4348V14.1241L16.3106 20H19.9466C19.9644 19.9822 19.9822 19.9644 20.0001 19.9465C20.0001 18.5991 20.0001 17.3968 20.0001 16.3108L14.1241 10.4348H20Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.1181 2.6084C6.99004 4.38957 4.38949 6.99004 2.6084 10.1181V19.9997H7.82582V7.82598V7.82582H19.9997C19.9997 6.18027 19.9997 4.61262 19.9997 2.6084H10.1181Z"
        fill="#D80027"
      />
      <path
        d="M19.9993 17.5403L12.8935 10.4346H10.4341V10.4347L19.9992 19.9997H19.9993C19.9993 19.9997 19.9993 18.3039 19.9993 17.5403Z"
        fill="#D80027"
      />
      <path
        d="M31.3042 12.175L28.6955 13.0446L26.0868 12.175L25.2173 10.0011L26.0868 7.82715H31.3042L30.4346 10.0011L31.3042 12.175Z"
        fill="#ACABB1"
      />
      <path
        d="M22.6084 12.1729V21.738C22.6084 26.3974 28.6954 27.825 28.6954 27.825C28.6954 27.825 34.7823 26.3974 34.7823 21.738V12.1729H22.6084Z"
        fill="#338AF3"
      />
      <path
        d="M23.1577 24.0057C24.654 26.8783 28.696 27.8266 28.696 27.8266C28.696 27.8266 32.738 26.8783 34.2343 24.0057L28.696 14.7832L23.1577 24.0057Z"
        fill="#6DA544"
      />
      <path
        d="M34.7823 21.6414L28.6954 12.1729L22.6084 21.6414V21.738C22.6084 22.6004 22.8173 23.3518 23.1571 24.0041L28.6954 15.3889L34.2336 24.004C34.5734 23.3516 34.7823 22.6003 34.7823 21.7379V21.6414Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112161">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default PitcairnIslandsSvg;
